import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $convertToMarkdownString, TRANSFORMERS } from '@lexical/markdown';
import type { Transformer } from '@lexical/markdown';
import { useEffect } from 'react';

interface OnChangeMarkdownProps {
  onChange: (markdown: string) => void;
  /** Optional transformer list. Defaults to TRANSFORMERS when omitted. */
  transformers?: Transformer[];
}

export function OnChangeMarkdown({
  onChange,
  transformers,
}: OnChangeMarkdownProps) {
  const [editor] = useLexicalComposerContext();
  const activeTransformers = transformers ?? TRANSFORMERS;

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const markdown = $convertToMarkdownString(activeTransformers);
        onChange(markdown);
      });
    });
  }, [editor, onChange, activeTransformers]);

  return null;
}
